import { settings } from './settings';

export * from './settings';
export * from './assets';
export * from './breakpoints';

/** Resolve debug mode from config flag or URL (`#debug` / `?debug`). Evaluated once at load. */
function resolveDebug(): boolean {
  if (settings.debug.forceEnabled) return true;
  if (typeof window === 'undefined') return false;
  const { hash, search } = window.location;
  return hash.includes('debug') || new URLSearchParams(search).has('debug');
}

export const isDebug: boolean = resolveDebug();
